import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { CommunicationProtocolEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class CommunicationProtocolSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    protocolCreated$() {
        return this.socketService.receiveMessageObserver(CommunicationProtocolEvents.CREATED);
    }

    protocolUpdated$() {
        return this.socketService.receiveMessageObserver(CommunicationProtocolEvents.UPDATED);
    }

    protocolDeleted$() {
        return this.socketService.receiveMessageObserver(CommunicationProtocolEvents.DELETED);
    }
}
